// extracted by mini-css-extract-plugin
module.exports = {"bannerWrap":"Banner_bannerWrap__jWkJ_","banner":"Banner_banner__yy8zo","content":"Banner_content__tfYgg","link":"Banner_link__ZMwNh","pipe":"Banner_pipe__lSYag"};